import { LegalPage, LegalSection } from "@/components/LegalPage";

// Contenido provisional. Sustituir por la política definitiva revisada
// legalmente (RGPD / LOPD-GDD) antes del lanzamiento comercial.

export default function Privacy() {
    return (
        <LegalPage
            title="Política de Privacidad"
            updatedAt="2026-02-01"
            testId="privacy-page-root"
        >
            <p>
                En <strong>Loving Angels</strong> tu privacidad importa. Esta
                política explica qué datos recogemos, para qué los usamos y
                qué derechos tienes. Está redactada conforme al Reglamento
                General de Protección de Datos (RGPD) y la LOPD-GDD.
            </p>

            <LegalSection title="1. Responsable del tratamiento" id="responsable">
                <p>
                    El responsable del tratamiento es Loving Angels. Puedes
                    contactar con nosotros a través de{" "}
                    <a
                        href="mailto:hola@lovingangels.es"
                        className="underline underline-offset-2"
                    >
                        hola@lovingangels.es
                    </a>
                    .
                </p>
            </LegalSection>

            <LegalSection title="2. Datos que recogemos" id="datos">
                <p>
                    Al iniciar sesión con Google recogemos:
                </p>
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>Tu nombre público y foto de perfil.</li>
                    <li>Tu dirección de email.</li>
                    <li>Un identificador único de sesión (cookie httpOnly).</li>
                </ul>
                <p>
                    Además almacenamos el contenido que tú introduces en el
                    editor (nombres de la pareja, fecha, mensajes, fotos,
                    lista de invitados y sus dietas). No accedemos ni
                    compartimos estos datos con terceros salvo lo indicado
                    en la sección &laquo;Encargados del tratamiento&raquo;.
                </p>
            </LegalSection>

            <LegalSection title="3. Finalidad del tratamiento" id="finalidad">
                <p>
                    Usamos tus datos para:
                </p>
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>Prestarte el servicio de creación de la web.</li>
                    <li>
                        Enviarte un único email de bienvenida tras registrarte
                        (vía Resend).
                    </li>
                    <li>
                        Procesar el pago de 39 € cuando decidas publicar
                        (vía Stripe).
                    </li>
                    <li>
                        Mostrar públicamente tu web de boda en la URL
                        elegida.
                    </li>
                </ul>
                <p>
                    <strong>No usamos tus datos para publicidad</strong>. No
                    vendemos, alquilamos ni compartimos tu email con
                    terceros.
                </p>
            </LegalSection>

            <LegalSection title="4. Base legal" id="base-legal">
                <p>
                    El tratamiento se basa en la ejecución del contrato de
                    prestación de servicios (art. 6.1.b RGPD) y en tu
                    consentimiento expreso al iniciar sesión y aceptar los
                    Términos.
                </p>
            </LegalSection>

            <LegalSection title="5. Encargados del tratamiento" id="encargados">
                <p>
                    Para prestar el servicio compartimos datos estrictamente
                    necesarios con los siguientes proveedores:
                </p>
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>
                        <strong>Google (OAuth)</strong> — autenticación.
                    </li>
                    <li>
                        <strong>Stripe</strong> — procesamiento del pago
                        (PCI-DSS certificado).
                    </li>
                    <li>
                        <strong>Resend</strong> — envío del email de
                        bienvenida.
                    </li>
                    <li>
                        <strong>Emergent</strong> — infraestructura de
                        hosting.
                    </li>
                </ul>
                <p>
                    Todos ellos cumplen con el RGPD y tienen firmadas las
                    correspondientes cláusulas de tratamiento de datos.
                </p>
            </LegalSection>

            <LegalSection title="6. Conservación" id="conservacion">
                <p>
                    Conservamos tus datos mientras mantengas tu cuenta
                    activa. Si eliminas tu cuenta o solicitas su borrado
                    (ver derechos), eliminaremos todos tus datos en un plazo
                    máximo de 30 días, salvo obligación legal de retención
                    (por ejemplo, facturación).
                </p>
            </LegalSection>

            <LegalSection title="7. Tus derechos" id="derechos">
                <p>
                    Como titular de los datos tienes derecho a:
                </p>
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>Acceder a los datos que tenemos sobre ti.</li>
                    <li>Rectificar datos inexactos.</li>
                    <li>Solicitar la supresión (&laquo;derecho al olvido&raquo;).</li>
                    <li>Oponerte al tratamiento o solicitar su limitación.</li>
                    <li>Portabilidad de tus datos.</li>
                    <li>
                        Retirar el consentimiento en cualquier momento.
                    </li>
                    <li>
                        Reclamar ante la Agencia Española de Protección de
                        Datos (AEPD).
                    </li>
                </ul>
                <p>
                    Para ejercer cualquiera de estos derechos escríbenos a{" "}
                    <a
                        href="mailto:hola@lovingangels.es"
                        className="underline underline-offset-2"
                    >
                        hola@lovingangels.es
                    </a>{" "}
                    desde el email de tu cuenta.
                </p>
            </LegalSection>

            <LegalSection title="8. Cookies" id="cookies">
                <p>
                    Utilizamos exclusivamente cookies técnicas necesarias
                    para el funcionamiento del servicio:
                </p>
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>
                        <code>session_token</code> — mantiene tu sesión
                        iniciada (httpOnly, secure, expira en 7 días).
                    </li>
                </ul>
                <p>
                    No utilizamos cookies de tracking publicitario ni de
                    analítica comportamental de terceros.
                </p>
            </LegalSection>

            <LegalSection title="9. Seguridad" id="seguridad">
                <p>
                    Aplicamos medidas técnicas y organizativas apropiadas:
                    cifrado TLS en tránsito, tokens de sesión httpOnly, y
                    control de acceso por usuario para cada web de boda.
                </p>
            </LegalSection>

            <LegalSection title="10. Cambios en esta política" id="cambios">
                <p>
                    Te notificaremos por email cualquier cambio material en
                    esta política. La fecha &laquo;Última actualización&raquo; al
                    inicio de este documento refleja la versión vigente.
                </p>
            </LegalSection>
        </LegalPage>
    );
}
